import gsap from 'gsap'

export const setTab = (container, trigger) => {
	let el = container.querySelector('[data-tabs]')

	if (!el) return

	let background = el.querySelector('[data-background]'),
		active = el.querySelector('[data-status="active"]')

	if (background && active) {
		background.style.left = active.offsetLeft + 'px'
		background.style.width = active.offsetWidth + 'px'
	}
}

export const navigateTab = (container, trigger) => {
	let el = container.querySelector('[data-tabs]'),
		background = el.querySelector('[data-background]'),
		active = el.querySelector('[data-status="active"]')

	// el.style.background = "red"

	container.parentElement.appendChild(el)

	active.setAttribute('data-status', 'inactive')

	trigger.parentElement.setAttribute('data-status', 'active')

	gsap.to(background, {
		width: trigger.parentElement.offsetWidth,
		left: trigger.parentElement.offsetLeft
	})

	setTimeout(() => el.remove(), 1000)
}

export default () => {}
